/** Returns true if URL points to a video file (mp4/mov/webm). */
export const isVideoMedia = (url, mediaType) => {
  if (mediaType === 'video') return true;
  if (!url) return false;
  return /\.(mp4|mov|webm)(\?.*)?$/i.test(url);
};
